import { Button, Modal, ModalProps } from '@payaca/ambrosia';
import { FC } from 'react';

type Props = {
  isProcessing?: boolean;
  onConfirm: () => void;
} & Omit<ModalProps, 'title'>;

const ConfirmDeleteSupplierMaterialModal: FC<Props> = (props) => {
  const { isProcessing = false, onConfirm, ...rest } = props;

  return (
    <Modal title="Delete supplier material" {...rest}>
      <Modal.Body>
        <p>Are you sure you want to delete this supplier material?</p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            isProcessing={isProcessing}
            onClick={onConfirm}
            colour="negative"
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteSupplierMaterialModal;
